import * as z from "zod"
import { DocumentType } from "@prisma/client"

export const DocumentModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  filename: z.string(),
  original_filename: z.string(),
  type: z.nativeEnum(DocumentType).nullish(),
  request_id: z.number().int().nullish(),
  account_id: z.number().int().nullish(),
  author_id: z.number().int().nullish(),
  approved_at: z.date().nullish(),
  approved_by_id: z.number().int().nullish(),
  shipment_form_id: z.number().int().nullish(),
  provider_id: z.string().nullish(),
  request_draft_id: z.number().int().nullish(),
})
